import configs from "@/i18n/configs"
export default {
    'pharmaceutical-forms': `${configs.pharmaceuticalForms.en}`,
    'add-product': 'Add product',
    'edit-product': 'Edit product',
    'the-product': 'product data?',
    'activate-/-deactivated': 'Activate / Deactivated material',
    'active': 'Active',
    'inactive': 'InActive',
    'all': 'All',
    'toggle-item-status': 'Toggle item status',
    'the-selected-item': 'the selected item',
    'deactivated': 'deactivated'
}